const map = {
	"./Accounts.vue": [
		19760,
		[
			760
		]
	],
	"./Categories.vue": [
		73471,
		[
			471
		]
	],
	"./Dashboard.vue": [
		60487,
		[
			487
		]
	],
	"./Login.vue": [
		64591,
		[
			591
		]
	],
	"./Material.vue": [
		36154,
		[
			154
		]
	],
	"./Orders.vue": [
		49410,
		[
			410
		]
	],
	"./PermissionManager.vue": [
		55921,
		[
			921
		]
	],
	"./Products.vue": [
		99569,
		[
			569
		]
	],
	"./Stalls.vue": [
		64522,
		[
			522
		]
	],
	"./Stats.vue": [
		87093,
		[
			93
		]
	],
	"./Verify.vue": [
		22144,
		[
			144
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72841;
module.exports = webpackAsyncContext;